import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LorpDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-lorp',
  templateUrl: './lorp.component.html',
  styleUrls: ['./lorp.component.scss']
})
export class LorpComponent implements OnChanges {


  lorpForm: FormGroup;
  lorpFormArray: FormGroup;
  control = new FormControl();
  @Input() lorps: LorpDto[];
  @Input() routeAnimationsElements: any;
  @Output() lorp = new EventEmitter<LorpDto[]>()
  @Output() deleteLorpEvent = new EventEmitter<any>()

    selectedLorp: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createLorpForm();
    }

    createLorpForm() {
      this.lorpForm = this.fb.group({
        LorpName: ['', Validators.required],
   
        id: null
        });
        this.lorpFormArray = this.fb.group({ Lorps: this.fb.array([])
          });
        this.setLorp();
    }

  // method to display lorps
  setLorp() {
    const control  = this.lorpFormArray.controls.Lorps as FormArray;
    this.lorps.forEach( e => {
      control.push(
        this.fb.group({
          LorpName: e.LorpName,
      
          id: e.id
        })
      );
    });
  }


  // method to add Lorp
  addLorp(value: LorpDto) {
    const control  = this.lorpFormArray.controls.Lorps as FormArray;
    control.insert(0,
          this.fb.group({
            LorpName: value.LorpName,
          
            id: null
          })
       );
  }

  selectLorp(value) {}

  // method to delete lorp from arrary list
  deleteLorp(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.lorpFormArray.controls.Lorps as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.lorps.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.lorps[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: LorpDto) {
    if(this.lorpForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.lorpFormArray.get('Lorps')['controls'][this.selectedIndex].patchValue({LorpName: formValue.LorpName});
    } else {
      this.addLorp(formValue);
    }
    this.selectedIndex = null;
    this.lorpForm.reset()
  }

  onEdit(index, value: LorpDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.lorpForm.patchValue({LorpName: value.LorpName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.lorpForm.reset();
  }

  onSubmit(formValue: LorpDto[]) {
  this.lorp.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteLorpEvent.emit(this.filteredDelete);
  }
  }

}
